import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { Card, CardContent } from '@/components/ui/card'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { PrivilegeType, type PrivilegeFilters } from './privilege.types'

interface PrivilegeFilterProps {
  filters: PrivilegeFilters
  onFiltersChange: (filters: PrivilegeFilters) => void
  onAddClick: () => void
}

export default function PrivilegeFilter({
  filters,
  onFiltersChange,
  onAddClick,
}: PrivilegeFilterProps) {
  const typeOptions: { label: string; value: PrivilegeType }[] = [
    { label: 'ทั้งหมด', value: PrivilegeType.ALL },
    { label: 'สินค้า', value: PrivilegeType.ITEM },
    { label: 'คูปอง', value: PrivilegeType.COUPON },
  ]

  const statusOptions: { label: string; value: string }[] = [
    { label: 'ทั้งหมด', value: 'all' },
    { label: 'เปิดใช้งาน', value: 'true' },
    { label: 'ปิดใช้งาน', value: 'false' },
  ]

  const handleTypeChange = (value: PrivilegeType) => {
    onFiltersChange({
      ...filters,
      type: value,
      page: 1,
    })
  }

  const handleStatusChange = (value: string) => {
    const isEnable = value === 'all' ? undefined : value === 'true'
    onFiltersChange({
      ...filters,
      isEnable,
      page: 1,
    })
  }

  const getStatusValue = () => {
    if (filters.isEnable === undefined) return 'all'
    return filters.isEnable ? 'true' : 'false'
  }

  return (
    <Card>
      <CardContent>
        <div className="flex flex-col gap-6">
          {/* Header with Add Button */}
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-black">
              จัดการของรางวัล
            </h2>
            <Button onClick={onAddClick}>เพิ่มของรางวัล</Button>
          </div>

          <Separator className="border-gray-200" />

          <div className="flex gap-6 flex-wrap">
            {/* Filters Row */}
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 mb-1">ประเภท</p>
              <Select value={filters.type} onValueChange={handleTypeChange}>
                <SelectTrigger className="min-w-[140px]">
                  <SelectValue placeholder="เลือกประเภท" />
                </SelectTrigger>
                <SelectContent>
                  {typeOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 mb-1">สถานะ</p>
              <Select
                value={getStatusValue()}
                onValueChange={handleStatusChange}
              >
                <SelectTrigger className="min-w-[140px]">
                  <SelectValue placeholder="เลือกสถานะ" />
                </SelectTrigger>
                <SelectContent>
                  {statusOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
